import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useListAccounts } from "@/lib/api/otc";
import { useListCustomers } from "@/lib/api/customer";
import { OtcContractFormV2, contractToForm } from "@/section/otc/contract-form-v2";

export function ContractPreviewDialog({ 
    isOpen, 
    onClose, 
    contract 
}: { 
    isOpen: boolean; 
    onClose: () => void; 
    contract: any;
}) {
    const listAccountsRes = useListAccounts(false);
    const listCustomersRes = useListCustomers({ minimal: true, hasRiskProfile: true });
    
    if (!contract) return null;
    
    const accounts = listAccountsRes?.data?.data || [];
    const customers = listCustomersRes?.data?.data || [];
    const initialValues = contractToForm(contract as Record<string, unknown>);
    
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-screen-2xl md:min-w-sm lg:min-w-md xl:mg-w-lg">
                <DialogHeader>
                    <DialogTitle>Contract Details - {contract.contract_no}</DialogTitle>
                    <DialogDescription>
                        Viewing OTC contract in read-only mode
                    </DialogDescription>
                </DialogHeader>
                
                {isOpen && (
                    <OtcContractFormV2
                        isPreviewOnly={true}
                        accounts={accounts}
                        customers={customers}
                        isUpdateForm={true}
                        initialValues={initialValues}
                        onSubmit={async () => false}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
